module.exports = __webpack_public_path__ + "static/media/flag-en.683f0ef1.svg";